import React, { useMemo } from 'react';
import moment from 'moment';
import { List, Typography, Tag, Card, Empty } from 'antd';

const { Text } = Typography;

const DueTaskList = ({ tasks }) => {
  const dueTasks = useMemo(() => {
    if (!tasks || tasks.length === 0) {
      return [];
    }

    const now = moment();
    const thirtyDaysFromNow = moment().add(30, 'days'); // Changed from 7 to 30 days

    return tasks
      .filter(task => {
        if (task.originalEventType !== 'order' || !task.originalEventDetails) {
          return false;
        }
        const { status, endDate } = task.originalEventDetails;
        const isActiveOrPending = status === 'Active' || status === 'Pending';
        
        if (!isActiveOrPending) return false;
        if (!endDate) return false; // Only consider tasks with a defined end date for "due"

        const taskEndDate = moment(endDate);
        return taskEndDate.isSameOrAfter(now, 'day') && taskEndDate.isSameOrBefore(thirtyDaysFromNow, 'day'); // Changed to thirtyDaysFromNow
      })
      .sort((a, b) => moment(a.originalEventDetails.endDate).diff(moment(b.originalEventDetails.endDate)));
  }, [tasks]);

  if (dueTasks.length === 0) {
    return (
      <Card title="Due Tasks (Next 30 Days)"> 
        <Empty description="No upcoming due tasks." image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </Card>
    );
  }

  return (
    <Card title="Due Tasks (Next 30 Days)"> 
      <List
        itemLayout="horizontal"
        dataSource={dueTasks}
        renderItem={item => {
          const details = item.originalEventDetails;
          return (
            <List.Item>
              <List.Item.Meta
                avatar={<Tag color={details.color} style={{ minWidth: '20px', height: '20px', marginRight: '8px' }} />}
                title={<Text strong>{item.name}</Text>}
                description={
                  <>
                    <Text>Category: {details.categoryName}</Text><br />
                    <Text type="secondary">Due: {moment(details.endDate).format('MMM DD, YYYY')} ({moment(details.endDate).fromNow()})</Text><br/>
                    <Text type="secondary">Status: {details.status}</Text>
                  </>
                }
              />
            </List.Item>
          );
        }}
      />
    </Card>
  );
};

export default DueTaskList;
